import { createSlice } from "@reduxjs/toolkit";
import { ReducerRegistry } from "@neumetric/blueprint-lib/store";

const initialState = {
  statistics: { severity: [], department: [] },
  dateRangeEnumns: [],
  activeGuides: null,
  showGuide: null,
  remediatorStats: null,
  remediatorStatsLoading: false,
  currentDateRange: { id: "last_365_days", label: "Last 365 Days" },
  currentOrgLogo: null,
  mitigatorDashboardData: [],
};
const centralSlice = createSlice({
  name: "central",
  initialState: initialState,
  reducers: {
    fetchCentralGuides: () => {},
    fetchDateRangeEnums: () => {},
    fetchCurrentOrgLogo: () => {},
    fetchRemediatorStats: () => {},
    fetchMitigatorDashboardData: () => {},
    setCurrentOrgLogo: (state, action) => {
      state.currentOrgLogo = action.payload;
    },
    setDateRangeEnums: (state, action) => {
      state.dateRangeEnumns = action.payload;
    },
    setGuides: (state, action) => {
      state.activeGuides = action.payload;
    },
    setShowGuide: (state, action) => {
      state.showGuide = action.payload;
    },
    setCurrentDateRange: (state, action) => {
      state.currentDateRange = action.payload;
    },
    setRemediatorStats: (state, action) => {
      state.remediatorStats = action.payload;
    },
    setRemediatorStatsLoading: (state, action) => {
      state.remediatorStatsLoading = action.payload;
    },
    setMitigatorDashboardData: (state, action) => {
      state.mitigatorDashboardData = action.payload;
    },
  },
});
export const centralActions = centralSlice.actions;

ReducerRegistry.register("central", centralSlice.reducer);
